<div class="rs-panel-flex-cell rs-bg-c2">
  <p>
    <strong>{{ 'password.recovery.method.email.title' | translate }}</strong>
  </p>
  <p *ngIf="!showAddMail">
    <button
      class="rs-link-action rs-link-action-add"
      (click)="toggleShowAddMail()"
      data-cy="recoveryMailAddLink"
    >
      <span class="rs-link-action-label" aria-hidden="true">{{
        'password.recovery.method.email.add.title' | translate
      }}</span
      ><span
        class="rs-action-link-icon"
        title="{{ 'password.recovery.method.email.add.title' | translate }}"
        ><span class="show-for-sr">{{
          'password.recovery.method.email.add.title' | translate
        }}</span></span
      >
    </button>
  </p>
  <span *ngIf="showAddMail">
    <span class="rs-label">{{ 'password.recovery.method.email.add.description' | translate }}</span>
    <mprd-email-submit
      (validEmailSubmit)="onValidEmailSubmit($event)"
      (emailSubmitCancel)="onEmailSubmitCancel()"
    ></mprd-email-submit>
    <p class="right rs-margin-right2">
      <span *ngIf="showLoadingSpinner">
        <px-loading-spinner></px-loading-spinner>
      </span>
    </p>
  </span>
</div>
